// Feature Carousel (StudioC_FeatureCarousel). Global script - loaded on every site.
// Only touches .fs-track elements that carry a data-slides attribute; the view omits
// that attribute in design/preview mode and for single-slide sections, so this script
// has nothing to do there.
(function ($) {
    if (!$ || !$.fn || !$.fn.slick) { return; }

    function initFeatureCarousels() {
        $('.fs-track[data-slides]').each(function () {
            var $track = $(this);
            if ($track.hasClass('slick-initialized')) { return; }

            var slideCount = parseInt($track.attr('data-slides'), 10);
            if (!slideCount || slideCount < 2) { return; }

            var prefersReducedMotion = window.matchMedia &&
                window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            // Arrows and dots render into this shared row below the track (instead of
            // Slick's default arrows-over-the-slide placement) so they never sit on top
            // of a slide's image or video.
            var $controls = $track.next('.fs-controls');

            $track.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                // Every slide shares the height of the tallest slide (default Slick
                // behavior) instead of the track resizing per slide.
                adaptiveHeight: false,
                arrows: $track.attr('data-fs-arrows') === 'true',
                dots: $track.attr('data-fs-dots') === 'true',
                appendArrows: $controls.length ? $controls : undefined,
                appendDots: $controls.length ? $controls : undefined,
                autoplay: !prefersReducedMotion && $track.attr('data-fs-autoplay') === 'true',
                autoplaySpeed: parseInt($track.attr('data-fs-interval'), 10) || 6000,
                fade: $track.attr('data-fs-fade') === 'true',
                infinite: $track.attr('data-fs-loop') === 'true',
                pauseOnHover: true,
                pauseOnFocus: true,
                accessibility: true
            });

            var label = $track.find('.fs-heading').first().text();
            $track.attr({
                'role': 'region',
                'aria-roledescription': 'carousel'
            });
            if (label) {
                $track.attr('aria-label', $.trim(label));
            }
        });
    }

    $(document).ready(initFeatureCarousels);
})(window.jQuery);
